import { DomainEvent, DomainEventType } from '../event';

export type JobReviewOfflineStorageChangePayload = {
    jobId: string;
};

export class JobReviewOfflineStorageChangeEvent extends DomainEvent<JobReviewOfflineStorageChangePayload> {
    constructor(payload: JobReviewOfflineStorageChangePayload) {
        super(DomainEventType.JOB_REVIEW_OFFLINE_STORAGE_CHANGE, payload);
    }
}
